import { render, staticRenderFns } from "./AssessmentShortReport.vue?vue&type=template&id=12094d2e&scoped=true&"
import script from "./AssessmentShortReport.vue?vue&type=script&lang=ts&"
export * from "./AssessmentShortReport.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentShortReport.vue?vue&type=style&index=0&id=12094d2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12094d2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCol,VIcon,VProgressCircular,VRow,VSkeletonLoader})
